export enum PAYMENT_METHOD_KEYS {
    AMAZON_PAY = 'AmazonPay',
    INVOICE = 'Invoice',
    PAYPAL_CHECKOUT = 'PayPalCheckout',
    PAYPAL_CHECKOUT_CREDIT_CARD = 'PayPalCheckoutCreditCard',
    PAYPAL_CHECKOUT_SEPA = 'PayPalCheckoutSepa',
    GOOGLE_PAY = 'GooglePay',
    APPLE_PAY = 'ApplePay',
    KLARNA_PAY = 'KlarnaPayNow',
    SEPA_PAY = 'SEPA',
    CARD = 'AdyenCard',
    IDEAL = 'iDEAL',
    BANCONTACT_CARD = 'BancontactCard',
    BANCONTACT_MOBILE = 'BancontactMobile',
    CARTA_DEL_DOCENTE = 'CartaDelDocente',

    // --- Kushki Methods ---
    KUSHKI_CARD = 'KushkiCard',
    KUSHKI_CASH = 'KushkiCash',
    KUSHKI_TRANSFER = 'KushkiTransfer'
}
